// extracted by mini-css-extract-plugin
module.exports = {"base":"fiveOpinionStories-m__base__3dWrD","container":"fiveOpinionStories-m__container__1mXRm"};